import { useMutation } from '@tanstack/react-query';
import type { UseMutationResult } from '@tanstack/react-query';
import { apiClient } from '@/core/http/client';
import type { ApiError } from '@/models/apiError';
import type { components } from '@/generated/api/schema';

/** One-time DATEXT launch URL — must never be logged, persisted or cached. */
export type DatextLaunch = components['schemas']['DatextLaunchResponse'];

/**
 * Requests a one-time DATEXT launch URL (`POST /api/v1/abrechnung/datext/linkout`). Deliberately a
 * mutation, not a query, so the AUTH-bearing URL never enters the query cache.
 */
export function useCreateDatextLinkout(): UseMutationResult<DatextLaunch, ApiError, void> {
  return useMutation({
    mutationFn: async (): Promise<DatextLaunch> => {
      const { data } = await apiClient.POST('/api/v1/abrechnung/datext/linkout');
      // The middleware throws ApiError for non-2xx responses before reaching here.
      return data as DatextLaunch;
    },
  });
}
